import React from "react";

const Testimonials = () => {
  return <section id="testimonials"></section>;
};

export default Testimonials;
